import { useQuery } from '@tanstack/react-query'
import { Portfolio } from '@/types/portfolio'

export const useRecommendedPortfolios = () => {
  const { data, isLoading } = useQuery<Portfolio[]>({
    queryKey: ['recommended-portfolios'],
    queryFn: async () => {
      const r = await fetch(`/api/portfolio/recommended`).then((res) => res.json())
      return r.data
    },
    refetchInterval: 10000,
  })

  return { recommendedPortfolios: data, isLoading }
}
